export default "__VITE_ASSET__CdqJgz_k__"